import {action, observable} from 'mobx';
import GenericFormStore from '../../../stores/FormStore';

class ChangePasswordStore extends GenericFormStore {
    @observable changePasswordSucces = false;
    @observable form = ChangePasswordStore._init();

    static _init() {
        return {
            fields: {
                oldPassword: {
                    value: '',
                    error: '',
                    rule: 'required|password',
                },
                password: {
                    value: '',
                    error: '',
                    rule: 'required|password|confirmed',
                },
                password_confirmation: {
                    value: '',
                    error: '',
                    rule: 'required|password',
                },
            },
            meta: {
                isValid: false,
                error: null,
            },
        };
    }

    @action
    toggleChangePasswordSucces = (val) => {
        this.changePasswordSucces = val;
    };

    @action
    resetFields = () => {
        this.form = ChangePasswordStore._init();
    };

    @action setOldPasswordDefaultValue = () => {
        this.form.fields.oldPassword.value = '********';
    }
}

const changePasswordStore = new ChangePasswordStore();
export default changePasswordStore;
